/* eslint semi:0 */
import cookie from 'cookie'
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

let allCookies = cookie.parse(document.cookie)
let epoch = new Date('Thu, 01 Jan 1970 00:00:01 GMT')

export function get(name) {
  return allCookies[name]
}

export function set(name, value, options = {}) {
  document.cookie = cookie.serialize(name, value, options)
  allCookies = cookie.parse(document.cookie)
}

export function expire(name) {
  document.cookie = cookie.serialize(name, '', { expires: epoch })
  allCookies = cookie.parse(document.cookie)
}

let cookies = Object.assign(makeEmptyObj(), {
  get,
  set,
  expire,
})

registerUtils({ cookies })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/cookies.js